var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 0.666656C4.39795 0.666656 0.666992 4.39762 0.666992 8.99999C0.666992 13.6024 4.39795 17.3333 9.00033 17.3333C13.6027 17.3333 17.3337 13.6024 17.3337 8.99999C17.3337 6.78985 16.4557 4.67024 14.8929 3.10743C13.3301 1.54463 11.2105 0.666656 9.00033 0.666656ZM9.00033 15.6667C5.31843 15.6667 2.33366 12.6819 2.33366 8.99999C2.33366 5.31809 5.31843 2.33332 9.00033 2.33332C12.6822 2.33332 15.667 5.31809 15.667 8.99999C15.667 10.7681 14.9646 12.4638 13.7144 13.714C12.4641 14.9643 10.7684 15.6667 9.00033 15.6667ZM11.6003 6.07499C11.7623 5.91618 12.0216 5.91618 12.1837 6.07499L12.6003 6.51666C12.6792 6.59489 12.7236 6.70139 12.7236 6.81249C12.7236 6.92359 12.6792 7.03009 12.6003 7.10832L7.91699 11.7917C7.84138 11.8722 7.73581 11.9179 7.62533 11.9179C7.51484 11.9179 7.40927 11.8722 7.33366 11.7917L5.37533 9.81666C5.29645 9.73842 5.25208 9.63192 5.25208 9.52082C5.25208 9.40972 5.29645 9.30323 5.37533 9.22499L5.81699 8.78332C5.8926 8.70276 5.99817 8.65706 6.10866 8.65706C6.21915 8.65706 6.32471 8.70276 6.40033 8.78332L7.65033 10.025L11.6003 6.07499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckRound);
export default __webpack_public_path__ + "static/media/icon-check-round.5c5d36241a23586b63f85d9b3132c9ea.svg";
export { ForwardRef as ReactComponent };